
import { toNumber } from 'es-toolkit/compat';
import libraryPluralize from 'pluralize';

/* TODO(jacob, 2019-10-31): This library should probably be replaced by direct
uses of the pluralize library it now uses. I kept this library's interface
as-is for now to avoid having to do a big port, but it would be good to do as a
separate task in the future. */

export function pluralizeWord(numInput: number | string, word: string): string {
  const num = toNumber(numInput);
  return libraryPluralize(word, num);
}

/*
 * i.e.
 * No guests
 * 1 guest
 * 2 guests
 */
export function pluralize(numInput: number | string, word: string): string {
  const num = toNumber(numInput);
  if (num === 0) {
    return `No ${libraryPluralize(word)}`;
  }
  return libraryPluralize(word, num, true);
}
